import { Stack, Box } from '@mui/material';
import { TableSortDownIcon, TableSortUpIcon } from 'assets/icons';
import React, { FC } from 'react';

interface Props {
    isUp: boolean;
}

const SortIcon: FC<Props> = (props: Props) => {
    const { isUp } = props;
    const icon = isUp ? <TableSortUpIcon /> : <TableSortDownIcon />;
    return (
        <Stack direction="row" alignItems="center">
            {icon}
            <Box
                sx={{
                    fontSize: '18px',
                    color: 'var(--color-ebb02d)',
                    fontWeight: '400',
                }}>
                {isUp ? 'A' : 'D'}
            </Box>
        </Stack>
    );
};

export default SortIcon;
